export default function Footer() {
  return (
    <footer className="w-full flex flex-col items-center justify-center">
      <div className="w-full items-center p-3 bg-[#363636]">
        <div className="flex items-center justify-between md:max-w-7xl md:mx-auto py-6">
          <div className="flex items-center gap-4">
            <img src="/icon-white.png" alt="Pague Free Flow" className="" />
          </div>
          <div className="flex items-end justify-end gap-4 md:gap-8">
            <img src="/svg/logo-sem-parar.svg" alt="Sem Parar" className="w-[35px] h-[28px]  lg:w-[40px] lg:h-[32px]" />
          </div>
        </div>
      </div>
    </footer>
  );
} 